module.exports = __webpack_public_path__ + "img/hb.8212ffb9.jpg";